<template>
    <dialog :open="open" class="action-dialog">
        <h3>Дать admin-группу</h3>
        <label>Группа
            <select v-model="group">
                <option value="">— Выберите —</option>
                <option v-for="g in groups" :key="g" :value="g">{{ g }}</option>
            </select>
        </label>
        <div class="actions">
            <button class="btn btn--primary" :disabled="!group || busy" @click="submit">
                {{ busy ? 'Назначаю…' : 'Дать группу' }}
            </button>
            <button class="btn" @click="$emit('close')">Отмена</button>
        </div>
    </dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ open: boolean; userId: () => string }>();
const emit = defineEmits<{ (e: 'close'): void; (e: 'done'): void }>();

const groups = [
    'admin.dashboard', 'admin.support', 'admin.finance', 'admin.mentors',
    'admin.users', 'admin.consultations', 'admin.commerce', 'admin.events',
    'admin.reviews', 'admin.notifications', 'admin.conferences',
];
const group = ref('');
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/users/${props.userId()}/grant-admin-group/`,
            data: { group: group.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}
</script>

<style scoped>
.action-dialog {
    padding: 1.5rem;
    border-radius: var(--admin-radius-sm);
    border: 1px solid var(--admin-border);
    box-sizing: border-box;
    /* только max-width: на десктопе диалог остаётся fit-content, как был */
    max-width: min(440px, 92vw);
    max-height: 90vh;
    overflow-y: auto;
}
.action-dialog label {
    display: block;
    margin-bottom: 0.75rem;
}
.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

@media (max-width: 640px) {
    /* iOS зумит страницу при фокусе, если шрифт поля меньше 1rem */
    .action-dialog select { width: 100%; box-sizing: border-box; font-size: 1rem; min-height: 2.5rem; }
    .actions .btn { min-height: 2.5rem; }
}
</style>
